"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "currentColor",
    d: "M21.45,1.23a1.14,1.14,0,0,0-.32-.84A1.2,1.2,0,0,0,20.24,0L8.84,0A.65.65,0,0,0,8.6,0l-6,6a.59.59,0,0,0-.08.31V22.77A1.24,1.24,0,0,0,3.76,24H20.24a1.24,1.24,0,0,0,1.23-1.23l0-21.52ZM20.33,22.86H3.67V7H8.15A1.32,1.32,0,0,0,9.51,5.63l0-4.46H20.33Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "currentColor",
    d: "M6.27,12a1,1,0,0,0,1,1h9.43a1,1,0,0,0,0-2H7.29A1,1,0,0,0,6.27,12Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "currentColor",
    d: "M16.69,15.53H9.6a1,1,0,1,0,0,2h7.09a1,1,0,0,0,1-1A1,1,0,0,0,16.69,15.53Z"
  })]
}));